import { useRef, useEffect, useState } from 'react';
import Inputbox from './Inputbox';
import { countryData } from '../../utils/constants';
import DropDownIcon from '../../assets/images/dropdown.svg';

export default function PhoneNumberInputbox({
  disabled = false,
  phonenumber,
  onChange,
}) {
  const countryCodeRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [nationality, setNationality] = useState({
    flag: '',
    areaCode: '',
    country: '',
    isoCode3: '',
  });
  const [number, setNumber] = useState('');
  const onChangePhone = (value) => {
    if (value && !/^[0-9]+$/.test(value)) return;
    onChange('number', value);
  };

  useEffect(() => {
    const selectedPhone = countryData.filter(
      (item) => item.country == phonenumber.nationality.country
    );
    setNationality(
      selectedPhone.length
        ? selectedPhone[0]
        : {
            flag: '',
            areaCode: '',
            country: '',
            isoCode3: '',
          }
    );
    setNumber(phonenumber.number);
  }, [phonenumber]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        countryCodeRef.current &&
        !countryCodeRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="w-full flex items-center space-x-2">
      <div className="space-y-1 inline min-w-25 w-25">
        <div className="font-[poppins] text-xs text-[#414651] font-normal leading-[20px] tracking-[0%]">
          Área
        </div>

        <div className="relative" ref={countryCodeRef}>
          <button
            onClick={() => {
              if (!disabled) setOpen(!open);
            }}
            className="w-full px-3 py-2 flex items-center cursor-pointer justify-between focus:outline-none focus:border-[#414651] border border-gray-300 rounded-lg bg-white"
          >
            <div className="flex items-center space-x-1">
              {nationality.flag ? (
                <img src={nationality.flag} alt="Flag" className="w-5 h-5" />
              ) : (
                <div className="w-5 h-5 rounded-full overflow-hidden">
                  <div className="w-full h-2.5 bg-[#D5D7DA]"></div>
                  <div className="w-full h-[5px] bg-[#E9EAEB]"></div>
                  <div className="w-full h-[5px] bg-[#F5F5F5]"></div>
                </div>
              )}
              <span
                className={`font-[poppins] text-sm ${
                  nationality.areaCode ? 'text-[#414651]' : 'text-[#A4A7AE]'
                }`}
              >
                {nationality.areaCode ? nationality.areaCode : '+00'}
              </span>
            </div>
            <img src={DropDownIcon} alt="Drop Down Icon" className="w-5 h-5" />
          </button>

          {open && (
            <ul
              style={{ scrollbarWidth: 'thin' }}
              className="absolute z-10 mt-1 w-full max-h-56 h-56 overflow-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-transparent bg-white border border-gray-300 rounded-lg shadow"
            >
              {countryData.map((item, idx) => (
                <li
                  key={idx}
                  onClick={() => {
                    onChange('nationality', item);
                    setOpen(false);
                  }}
                  className="flex items-center px-4 py-2 space-x-2 hover:bg-gray-100 cursor-pointer"
                >
                  <img src={item.flag} alt="Flag" className="w-5 h-5" />
                  <span className="text-sm text-[#414651]">
                    {item.areaCode}
                  </span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      <Inputbox
        disabled={disabled}
        inputClass="bg-white"
        title="Teléfono"
        titleClass="text-[#424242]"
        placeholder="1122334455"
        value={number}
        onChange={onChangePhone}
      />
    </div>
  );
}
